import React from "react";
import generateIsolinesContours from "../../../../utils/isolines/isolines";
import { connect } from "react-redux";
import {
  centerMapSuccess,
  centerMapPlotSuccess,
  setInitMapPlotCenter,
  setIsolinesArrayLeafletId,
} from "../../../../redux/actions/resultsActions";
let isGenerating = false;
let isolinesQueue = [];
class Isolines extends React.Component {
  constructor(props) {
    super(props);
  }

  async componentDidMount() {
    // await this.drawIsolines({
    //   layerName: this.props.layerName,
    //   layerUrl: this.props.layerUrl,
    //   layerIndex: this.props.layerIndex,
    //   isolinesMin: this.props.isolinesMin,
    //   isolinesMax: this.props.isolinesMax,
    //   isolinesBreakNumber: this.props.isolinesBreakNumber,
    //   isolinesBreakInterval: this.props.isolinesBreakInterval,
    //   opacity: this.props.opacity,
    //   color: this.props.color,
    // });
    this.addToQueue({
      layerName: this.props.layerName,
      layerUrl: this.props.layerUrl,
      layerIndex: this.props.layerIndex,
      isolinesMin: this.props.isolinesMin,
      isolinesMax: this.props.isolinesMax,
      isolinesBreakNumber: this.props.isolinesBreakNumber,
      isolinesBreakInterval: this.props.isolinesBreakInterval,
      opacity: this.props.opacity,
      color: this.props.color,
    });
  }

  addToQueue = (isolineData) => {
    isolinesQueue.push(isolineData);
    this.processQueue();
  };

  processQueue = async () => {
    if (isGenerating || isolinesQueue.length === 0) {
      return;
    }
    isGenerating = true;
    const isolineData = isolinesQueue.shift();
    try {
      await this.drawIsolines(isolineData);
    } finally {
      isGenerating = false;
      this.processQueue();
    }
  };

  drawIsolines = async ({
    layerName,
    layerUrl,
    layerIndex,
    isolinesMin,
    isolinesMax,
    isolinesBreakInterval,
    isolinesBreakNumber,
    opacity,
    color,
  }) => {
    try {
      const isolines = await generateIsolinesContours(
        this.props.staticDriverMapRef.current,
        layerUrl,
        layerName,
        isolinesMin,
        isolinesMax,
        isolinesBreakInterval,
        isolinesBreakNumber,
        opacity,
        color
      );

      this.props.setIsolinesArrayLeafletId({
        isolinesLayerName: layerName,
        leafletId: isolines.leafletId,
      });

      if (
        this.props.isolinesLeafletArrayId.some(
          (x) => x.isolinesLayerName === layerName
        )
      ) {
        const layerNameNoWhiteSpace = layerName.replace(/\s/g, "");
        let elements = document.getElementsByClassName(layerNameNoWhiteSpace);
        if (layerIndex > 0) {
          for (let i = 0; i < elements.length; i++) {
            elements[i].style.display = "none";
          }
        } else {
          for (let i = 0; i < elements.length; i++) {
            elements[i].style.display = "block";
          }
        }
        return;
      }
    } catch (error) {
      console.error(`Error drawing ${layerName}:`, error);
    }
  };

  render() {
    return <></>;
  }
}

const mapStateToProps = (state) => ({
  isolinesLeafletArrayId: state.results.isolinesLeafletArrayId,
});

const mapDispatchToProps = (dispatch) => ({
  setIsolinesArrayLeafletId: (payload) =>
    dispatch(setIsolinesArrayLeafletId(payload)),
  centerMapSuccess: () => dispatch(centerMapSuccess()),
  centerMapPlotSuccess: () => dispatch(centerMapPlotSuccess()),
  setInitMapPlotCenter: (payload) => dispatch(setInitMapPlotCenter(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Isolines);
